import { PartType } from 'parts/enums';

export const getFocusElementNameAfterValidate = (
  isVerified: boolean,
  hasManufacturer: boolean,
  partType: PartType
) => {
  if (isVerified || partType === PartType.BOM) {
    return 'quantity';
  }

  if (hasManufacturer) {
    return 'description';
  }

  return 'manufacturer';
};
